<template>
  <v-col
    v-if="$vuetify.breakpoint.name == 'xs' || $vuetify.breakpoint.name == 'sm'"
    cols="12"
    class="pa-0 align-center"
    style="height: 100vh; display: flex;margin-top: -70px;"
  >

    <h2 class="text-center" style="width: 100%;">
      <v-icon x-large class="mb-5">mdi-close-octagon-outline</v-icon>
      <br />
      Not available on mobile
    </h2>
  </v-col>
  <v-container v-else fluid>
    <v-row cols="12" class="v-card v-sheet theme--light mx-auto fill-height" :style="`min-height: calc(100vh - 24px - ${!$store.state.auth.default_user ? '0px' : '24px'})`">
      <v-col :cols="bonusTemplate ? 6 : 12" class="transition-ease-in-out">
        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="filteredItems"
          :disable-pagination="true"
          fixed-header
          hide-default-footer
          single-select
          show-select
          item-key="sport_bonus_id"
          @item-selected="selectTemplate"
          class="th-nowrap"
          :height="`calc(100vh - 120px - ${!$store.state.auth.default_user ? '0px' : '24px'})`"
          :loading="loadingBonusTemplate"
        >
          <template v-slot:body.prepend>
            <tr v-if="Object.keys(filters).length > 0" class="">
              <td style="height: 35px;"></td>
              <td style="height: 35px;"></td>
              <td style="height: 35px;"></td>
              <td style="height: 35px;">
                <v-text-field
                  class="pt-0 mt-0"
                  v-model="filters.name.data"
                  :style="{width: (filters.name || {width: false}).width}"
                  hide-details
                />
              </td>
              <td style="height: 35px;"></td>
            </tr>
          </template>
          <template v-slot:top>
            <v-row class="mx-auto">
              <select-project
                v-model="entity_id"
              ></select-project>
              <v-checkbox
                label="Hide Inactive"
                v-model="hideInactive"
                hide-details
                class="ml-2"
              />
              <v-spacer></v-spacer>

              <v-btn
                v-if="$store.state.auth.checkAccess({key: 'bonus_template_update', value: true})"
                class="mt-3"
                color="success"
                @click="newTemplate()">
                <v-icon left>mdi-pencil</v-icon>
                New
              </v-btn>
            </v-row>
          </template>

        </v-data-table>
      </v-col>
      <v-col cols="6" class="transition-ease-in-out" :hidden="!bonusTemplate">
        <update-form
          :bonusTemplate="bonusTemplate"
          :loading="loadingBonusTemplate"
          @update-validation="updateFormValidation"
          class="overflow-y-auto"
          :style="`height: calc(100vh - 94px - ${!$store.state.auth.default_user ? '0px' : '24px'})`"
        />

        <v-divider class="mb-2" />

        <v-row class="mx-auto px-6 divider-border">
          <v-btn
            v-if="$store.state.auth.checkAccess({key: 'bonus_template_update', value: true})"
            :loading="loadingBonusTemplate"
            :disabled="!validUpdateForm"
            @click="save()"
            color="primary"
          >Save
          </v-btn>
          <v-spacer></v-spacer>
          <v-switch
            v-if="bonusTemplate"
            color="red"
            class="switch-deleted mt-0"
            v-model="bonusTemplate.deleted"
            :label="bonusTemplate.deleted ? 'Disabled' : 'Enabled'"
          ></v-switch>
          <v-spacer></v-spacer>
          <v-btn
            :loading="loadingBonusTemplate"
            @click="bonusTemplate = false; selected= [];"
            color="warning"
          >Close
          </v-btn>
        </v-row>
      </v-col>
    </v-row>

  </v-container>
</template>
<style>
  .nowrap,
  .th-nowrap th {
    white-space: nowrap;
  }

  .switch-deleted .v-input--selection-controls__ripple,
  .switch-deleted .v-input--switch__track,
  .switch-deleted .v-input--switch__thumb {
    color: #4CAF50 !important;
    caret-color: #4CAF50 !important;
  }

  .switch-deleted .red--text {
    color: #F44336 !important;
    caret-color: #F44336 !important;
  }
</style>

<script>
  import { API } from '@/utils/api'
  import { map, cloneDeep, filter, get, toString } from 'lodash'
  import SelectProject from '@/components/core/SelectProject/SelectProject.vue'

  export default {
    components: {
      SelectProject,
      UpdateForm: () => import('@/components/sport-bonus/UpdateForm'),
    },

    data: () => ({
      bonusTemplate: false,
      hideInactive: true,
      validUpdateForm: false,
      loadingBonusTemplate: false,
      selected: [],
      entity_id: null,
      headers: [
        { text: 'ID', value: 'sport_bonus_id', sortable: true },
        { text: 'Provider', value: 'system', sortable: true },
        { text: 'Name', value: 'name', sortable: true },
        { text: 'TemplateID', value: 'template_id', sortable: true },
      ],
      filters: {
        name: { data: [], type: 'text' },
      },
      items: [],
    }),

    computed: {
      filteredItems () {
        return this.items.filter(o => {
          return (this.hideInactive ? o.deleted == 0 : true) && (this.filters.name.data.length > 0 ? o.name.toLowerCase().indexOf(this.filters.name.data.toString().toLowerCase()) != -1 : true)
        })
      },
    },

    watch: {
      entity_id (val) {
        this.entity_id = val
        this.loadBonusTemplateList()
      },
    },

    methods: {
      updateFormValidation (value) {
        this.validUpdateForm = value
      },
      save () {
        if (!this.$store.state.auth.checkAccess({ key: 'bonus_template_update', value: true })) return

        this.$root.$confirm('Confirm', 'Save bonus template').then(r => {
          if (!r) return

          this.loadingBonusTemplate = true
          API.call('/$v/bonus_template/sport_bonus_update.json', { bonusTemplate: this.bonusTemplate }, null, this.bonusTemplate.entity_id)
            .then(resp => {
              this.bonusTemplate = resp.data
              return resp
            })
            .then(resp => {
              this.bonusTemplate = false
              this.selected = []
            })
            .then(resp => this.loadBonusTemplateList())
            .catch(e => {
            })
            .finally(() => {
              this.loadingBonusTemplate = false
            })
        })
      },

      newTemplate () {
        this.bonusTemplate = { new: true, system_id: null, rules: { name: '', template_id: '' }, entity_id: this.entity_id }
        this.loadingBonusTemplate = false
        this.selected = []
      },

      loadBonusTemplateList () {
        this.loadingBonusTemplate = true
        return API.call('/$v/bonus_template/sport_bonus_list.json', { deleted: [ 0, 1 ] }, null, this.entity_id).then(resp => {
          this.items = resp.data
        }).finally(() => {
          this.loadingBonusTemplate = false
        })
      },

      loadBonusTemplate (sport_bonus_id) {
        this.loadingBonusTemplate = true
        return API.call('/$v/bonus_template/sport_bonus_get.json', { sport_bonus_id }, null, this.entity_id).then(resp => {
          this.bonusTemplate = resp.data
        }).finally(() => {
          this.loadingBonusTemplate = false
        })
      },

      selectTemplate (data) {
        if (data.value) {
          this.loadBonusTemplate(data.item.sport_bonus_id)
        } else {
          this.bonusTemplate = false
        }
        // this.bonusTemplate = data.value ? cloneDeep(data.item) : false
      }
    }
  }
</script>
